import { Empresa } from '../entities/empresa';
export class DTOEntregaPedido{ 
    IdUsuario: number;
    DtEntrega: Date;
    Empresa: Empresa;
    PrimeiraCartela : string;
}


// WEBPACK FOOTER //
// ./src/dto/dtoEntregaPedido.ts